import React from 'react';
import { StepProps } from '../../types/form';
import { useReferenceData } from '../../context/ReferenceDataContext';
import { FormField } from '../ui/FormField';
import { ToggleGroup } from '../ui/ToggleGroup';
import { OptionMultiSelect } from '../ui/OptionMultiSelect';
export function MarketplaceStep({
  formData,
  updateFormData,
  errors
}: StepProps) {
  const {
    lawyers,
    isLoading
  } = useReferenceData();
  return <div className="space-y-6" data-id="element-155">
      <div data-id="element-156">
        <h2 className="text-lg font-semibold text-foreground" data-id="element-157">Marketplace & Inquiries</h2>
        <p className="text-sm text-muted-foreground" data-id="element-158">
          Can users request quotes from lawyers or submit legal inquiries?
        </p>
      </div>

      <FormField id="hasGetAQuote" label="Get a Quote" required error={errors.hasGetAQuote} data-id="element-159">
        <ToggleGroup value={formData.hasGetAQuote} onChange={val => updateFormData({
        hasGetAQuote: val
      })} options={[{
        label: 'On',
        value: true
      }, {
        label: 'Off',
        value: false
      }]} error={!!errors.hasGetAQuote} data-id="element-160" />
      </FormField>

      {formData.hasGetAQuote && <div className="space-y-4 pl-0 border-l-2 border-violet-blue/20 ml-1 pl-4" data-id="element-161">
          <FormField id="marketplaceLawyerIds" label="Which Lawyers Should Appear? (Optional)" hint="Leave empty to include all lawyers in the system." data-id="element-162">
            <OptionMultiSelect options={lawyers} selectedValues={formData.marketplaceLawyerIds} onChange={vals => updateFormData({
          marketplaceLawyerIds: vals
        })} placeholder="All lawyers (none selected)" loading={isLoading} showSelectAll={false} searchable searchPlaceholder="Search lawyers by name or email..." data-id="element-163" />
          </FormField>

          <FormField id="marketplaceDiscount" label="Discount on Quotes (%)" hint="Enter a percentage from 0 to 100. Leave empty for no discount." data-id="element-164">
            <input id="marketplaceDiscount" type="number" min="0" max="100" step="0.01" value={formData.marketplaceDiscount} onChange={e => {
          const raw = e.target.value;
          updateFormData({
            marketplaceDiscount: raw === '' ? '' : Number(raw)
          });
        }} className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-ring" placeholder="e.g. 15" data-id="element-165" />
          </FormField>
        </div>}

      <FormField id="hasLegalInquiryForm" label="Legal Inquiry Form" data-id="element-166">
        <label className="flex items-center gap-3 cursor-pointer" data-id="element-167">
          <input type="checkbox" checked={formData.hasLegalInquiryForm} onChange={e => updateFormData({
          hasLegalInquiryForm: e.target.checked
        })} className="h-4 w-4 rounded border-input" data-id="element-168" />
          <span className="text-sm text-foreground" data-id="element-169">Allow users to submit a legal inquiry form</span>
        </label>
      </FormField>
    </div>;
}